// import logo from './logo.svg';
// import './App.css';


function TTest() {
    return (
        <div className="App">
            <header className="App-header">
                <img src="logo.svg" className="App-logo" alt="logo" />
                <p>
                    Edit <code>src/App.js</code> and save to reload.
                </p>
                <a
                    className="App-link"
                    href="https://reactjs.org"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Learn React
                </a>
            </header>
        </div>
    );
}

// import {global} from './global'
// declare global {
//     TTest: any;
// }


// globalThis.TTest = TTest;
export default TTest;
// export const TTest = TTest;
